import moment from "moment-timezone"

export const formatToBrasilTimeZone = (data_hora) => {
    return moment(data_hora).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss')
}
export const formatDate = (data_hora) => {
    return moment(data_hora).tz('America/Sao_Paulo').format('DD/MM/YYYY')
}

